/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiGreetingsIdQueryResponse, GetApiGreetingsIdPathParams, GetApiGreetingsId400, GetApiGreetingsId401, GetApiGreetingsId403, GetApiGreetingsId404, GetApiGreetingsId500 } from "../../types/GetApiGreetingsId.ts";
import { getApiGreetingsIdQueryResponseSchema } from "../../zod/GreetingsSchemas/getApiGreetingsIdSchema.ts";

function getGetApiGreetingsIdUrl({ id }: { id: GetApiGreetingsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/greetings/${id}` as const }  
  return res
}

/**
 * @summary Получение шаблона приветственного экрана по идентификатору
 * {@link /api/greetings/:Id}
 */
export async function getApiGreetingsId({ id }: { id: GetApiGreetingsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiGreetingsIdQueryResponse, ResponseErrorConfig<GetApiGreetingsId400 | GetApiGreetingsId401 | GetApiGreetingsId403 | GetApiGreetingsId404 | GetApiGreetingsId500>, unknown>({ method : "GET", url : getGetApiGreetingsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiGreetingsIdQueryResponseSchema.parse(res.data)
}